import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { SignaturePolicy } from './signature-policy.model';

export const entityName = 'UserValidate';

@Injectable()
export class SignaturePolicyDataService extends EfaactDataService<SignaturePolicy> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        log.verbose({
            type: `${entityName}DataService(SignaturePolicyDataService)`,
            msg: '::'
        });
    }

    getById(id: string | number): Observable<SignaturePolicy> {
        this.log.verbose({
            type: `${entityName}DataService(SignaturePolicyDataService):getById`,
            id
        });
        return this.http
            .post<SignaturePolicy>(this.entitiesUrl, { validationcode: id })
            .pipe(
                map(item => this.mapItems(item)),
                catchError((e, c) =>
                    fromShared.Errors.handleDataServiceError(this.store, e, c)
                )
            );
    }

    mapItems(item: SignaturePolicy): SignaturePolicy {
        this.log.verbose({
            type: `${entityName}DataService(SignaturePolicyDataService):mapItems`,
            item
        });
        if (!item) {
            return;
        }
        return {
            ...item,
            id: 1
        };
    }
}
